import react, { useEffect, useMemo } from "react"
import { StyleObject } from "styletron-react"
import { AttentionPopover } from "."
import { colors, css, fonts, frames } from "../Styles"

import { useAppSelector } from "../Store"
import { Graph_QL } from "../Services"
import { useSystem } from "../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem"
import { useTranslation } from "react-i18next"

interface StatusBar_Props {
    overrides?:{
        gridArea?: string
    }
  }

export default function StatusBar({ overrides }: StatusBar_Props) {
  const {t} = useTranslation() 
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const {call: getSystemCall, data: systemsState} = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({fetchAmount: 50})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  
  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject,
        overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])
  
  return(
    <frames.StatusBar $style={_Root}>
      <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{t("systemControls.general.systemStatus", {defaultValue: "system status"})}</p>
      <div style={{ ...css.LanguageSelector_seperator }} />
      <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "center" }}>
        {systemsState[domain]?.data?.map((system) => (
          <AttentionPopover key={system.system_id} systemNo={system.system_id} />
        ))}
      </div>
    </frames.StatusBar>
  )
}
